import { Flex } from 'roo-ui/components';

const GroupItems = (props) => <Flex flex="1 1 auto" flexDirection="row" pt={3} {...props} />;

export default GroupItems;
